export default __webpack_public_path__ + "static/media/is-it-just-me.2c8e1c20.mp3";